/**
 * saas设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SaasUserManageService {
   //saasWebAPI微服务api
   prefix: string = environment.saasWebAPI;
   basicfix: string = environment.seekerWebAPI;
   sendCodeUrl: string = environment.smsWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 


  /**
   * 查询用户列表
   * @param param
   * @returns {Observable<any>}
   */
  queryPageList(param) {
    const url = this.prefix + 'customer/queryPageList';
    return this.http.Post(url, param);
  }

  //查看 
  queryById(param) {
    const url = this.prefix + 'customer/queryById';
    return this.http.Post(url, param);
  }

  //修改
  updateById(param) {
    const url = this.prefix + 'customer/updateById';
    return this.http.Post(url, param);
  }

  //租户认证查询
  customerAuthQuery(param) {
    const url = this.prefix +'authCompany/queryPageList';
    return this.http.Post(url, param);
  }

    //租户认证查询
    customerAuthQueryById(param) {
      const url = this.prefix +'authCompany/queryById';
      return this.http.Post(url, param);
    }

  //租户认证审批
  customerAuthApprove(param) {
    const url = this.prefix +'authCompany/approve';
    return this.http.Post(url, param);
  }

    //发送短信验证码
    querySmsVCode(param) {
      const url = this.sendCodeUrl+'saas/querySmsVCode?phone='+param;
      return this.http.Get(url, param);
    }
  //#endregion

}
